import { LocationStrategy } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { akitaConfig, resetStores } from '@state/signal-state.util';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  private location = inject(LocationStrategy);
  private metaTagService = inject(Meta);
  /**
   * Constructor
   */
  constructor() {
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }
  ngOnInit() {
    akitaConfig({ resettable: true });
    this.metaTagService.addTags([
      { name: 'description', content: 'Rtis' },
      {
        name: 'keywords',
        content:
          'Globalrtis, Global RTIS, RTIS, RTIS Global, RTIS Global, Resource Tracking Information System'
      },
      {
        name: 'author',
        content: 'Global RTIS'
      },
      {
        name: 'robots',
        content: 'index, follow'
      },
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1'
      },
      {
        name: 'date',
        content: '2022-06-01',
        scheme: 'yyyy-MM-DD'
      },
      {
        name: 'copyright',
        content: 'Global RTIS'
      },
      {
        name: 'language',
        content: 'en'
      },
      {
        charset: 'UTF-8'
      }
    ]);
  }
  ngOnDestroy() {
    resetStores();
  }
}
